// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/helpers.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_folder.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("styles/img/uploadAlt.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("styles/img/708-search.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("styles/img/icon_close--gray.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__children___mGPmZ {
  background-color: blue;
}

.styles__drag___QlmbX {
  border: 2px dashed gtGreen;
  background: #e2f1ee;
}

.styles__dropzoneArea___YjfxO {
  width: 100%;
  margin-bottom: 12px;
}

.styles__dropzoneDisabled___X2VLW {
  cursor: not-allowed !important;
  opacity: 0.6;
}

.styles__fileFolderIcon___LK1__ {
  float: left;
  height: 25px;
  width: 55px;
}

.styles__fileNameInput___dsamB {
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  width: 80%;
}

.styles__fileUploadButton___KTMFA {
  width: 18%;
}

.styles__folderIcon___uZ6VG {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat left;
}

.styles__folderCell___vAJeS .styles__childLink___u_tj4 {
  float: right;
}

.styles__hidden___NS9Fg {
  visibility: hidden;
}
.styles__none___SuBVX {
  display: none;
}

.styles__lowerUploadControls___EBYp7 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
  height: 30px;
}

::-webkit-input-placeholder {
  opacity: 0.7;
}

.styles__previewLink___yzCHd img {
  -webkit-text-decoration: none !important;
  text-decoration: none !important;
  border-width: 0;
}

.styles__upIcon___rM2hs {
  display: inline-block;
  vertical-align: middle;
  pointer-events: none;
  height: 80px;
  width: 50px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat left center;
  background-size: 32px;
}

.styles__uploadControls___ikGjd {
  width: 100%;
}
.styles__uploadControlsHorizontal___LPyEk {
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
  flex-direction: column;
}
.styles__uploadControlsHorizontal___LPyEk .styles__fileNameInput___dsamB {
    width: 100% !important;
    margin-right: 0.5rem;
  }
.styles__uploadControlsHorizontal___LPyEk .styles__fileUploadButton___KTMFA {
    width: 100% !important;
  }
.styles__uploadControlsHorizontal___LPyEk .styles__dropzoneArea___YjfxO {
    max-width: 460px;
    margin-right: 1rem;
  }

.styles__uploadText___px3Ua {
  pointer-events: none;
  display: inline-block;
  height: 80px;
}

/* Files table columns */

.styles__download___OIB2x {
  cursor: pointer;
}

.styles__preview___g9kku {
  height: 20px;
  width: 20px;
  background-position: center;
  background-size: 14px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  cursor: pointer;
  transition: opacity 0.2s;
}

.styles__preview___g9kku a {
    display: block;
    box-shadow: none;
    height: 20px;
    width: 20px;
  }

.styles__remove___O9yVx {
  height: 20px;
  width: 20px;
  background-position: center;
  background-size: 14px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  cursor: pointer;
  transition: opacity 0.2s;
  width: 10px;
}

.styles__remove___O9yVx a {
    display: block;
    box-shadow: none;
    height: 20px;
    width: 20px;
  }

/* Delete modal */

.styles__section___uR393 {
}

.styles__buttons___fACwt {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}

.styles__spacer___biZrX {
  display: inline-block;
  width: 1em;
}

.styles__removeBtn___GeAWJ {
}

.styles__cancelBtn___Y05sv {
}

.styles__deleteLink___S62Tz {
  padding-right: 10px !important;
  width: 40px !important;
  border-bottom: 0px !important;
  border-radius: 4px;
}

.styles__searchIcon____J9kL {
  padding-right: 0px !important;
  width: 40px !important;
  border-bottom: 0px !important;
}
.styles__tableRow___qjh8N {
  outline: auto;
  outline-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]};
  margin-bottom: 0.5rem;
  width: 100%;
}
.styles__tableRow___qjh8N .styles__tableCell___LdXRA {
    border-radius: 4px;
    border-bottom: 0px !important;
  }

.styles__dropzoneContainer___QxUCR {
  width: 100%;
  display: flex;
  gap: 0.5rem;
}

.styles__tableSection___nJadE {
  width: 100%;
  border: 0px !important;
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./universal/components/SimpleFileFolder/styles.css"],"names":[],"mappings":"AAIA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,8DAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EAEE,kEAA4D;AAC9D;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wCAAgC;EAAhC,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,yEAAiE;EACjE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,sBAAsB;AAaxB;AAXE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACA;IACE,sBAAsB;EACxB;AACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;AAGF;EACE,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;AACd;;AAEA,wBAAwB;;AAExB;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,qBAAqB;EACrB,4BAA4B;EAC5B,yDAAkD;EAClD,eAAe;EACf,wBAAwB;AAQ1B;;AANE;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;;AAGF;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,qBAAqB;EACrB,4BAA4B;EAC5B,yDAAwD;EACxD,eAAe;EACf,wBAAwB;EACxB,WAAW;AAOb;;AANE;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;;AAGF,iBAAiB;;AAEjB;AAEA;;AAEA;EACE,mBAAmB;EAEnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,2DAA0B;EAC1B,qBAAqB;EACrB,WAAW;AAMb;AAJE;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;AAGF;EACE,WAAW;EACX,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: 'styles/colors.css';\n@value gtGray, gtRed, textLight, borderColor from colors;\n\n.children {\n  background-color: blue;\n}\n\n.drag {\n  border: 2px dashed gtGreen;\n  background: #e2f1ee;\n}\n\n.dropzoneArea {\n  composes: dropzoneArea from helpers;\n  width: 100%;\n  margin-bottom: 12px;\n}\n\n.dropzoneDisabled {\n  cursor: not-allowed !important;\n  opacity: 0.6;\n}\n\n.fileFolderIcon {\n  float: left;\n  height: 25px;\n  width: 55px;\n}\n\n.fileNameInput {\n  border: 1px solid gtGray;\n  width: 80%;\n}\n\n.fileUploadButton {\n  width: 18%;\n}\n\n.folderIcon {\n  composes: fileFolderIcon;\n  background: url('styles/img/icon_folder.png') no-repeat left;\n}\n\n.folderCell .childLink {\n  float: right;\n}\n\n.hidden {\n  visibility: hidden;\n}\n.none {\n  display: none;\n}\n\n.lowerUploadControls {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-top: 10px;\n  height: 30px;\n}\n\n::-webkit-input-placeholder {\n  opacity: 0.7;\n}\n\n.previewLink img {\n  text-decoration: none !important;\n  border-width: 0;\n}\n\n.upIcon {\n  display: inline-block;\n  vertical-align: middle;\n  pointer-events: none;\n  height: 80px;\n  width: 50px;\n  background: url('styles/img/uploadAlt.png') no-repeat left center;\n  background-size: 32px;\n}\n\n.uploadControls {\n  width: 100%;\n}\n.uploadControlsHorizontal {\n  display: flex;\n  gap: 0.5rem;\n  align-items: flex-start;\n  flex-direction: column;\n\n  .fileNameInput {\n    width: 100% !important;\n    margin-right: 0.5rem;\n  }\n  .fileUploadButton {\n    width: 100% !important;\n  }\n  .dropzoneArea {\n    max-width: 460px;\n    margin-right: 1rem;\n  }\n}\n\n.uploadText {\n  pointer-events: none;\n  display: inline-block;\n  height: 80px;\n}\n\n/* Files table columns */\n\n.download {\n  cursor: pointer;\n}\n\n.preview {\n  height: 20px;\n  width: 20px;\n  background-position: center;\n  background-size: 14px;\n  background-repeat: no-repeat;\n  background-image: url('styles/img/708-search.png');\n  cursor: pointer;\n  transition: opacity 0.2s;\n\n  a {\n    display: block;\n    box-shadow: none;\n    height: 20px;\n    width: 20px;\n  }\n}\n\n.remove {\n  height: 20px;\n  width: 20px;\n  background-position: center;\n  background-size: 14px;\n  background-repeat: no-repeat;\n  background-image: url('styles/img/icon_close--gray.png');\n  cursor: pointer;\n  transition: opacity 0.2s;\n  width: 10px;\n  a {\n    display: block;\n    box-shadow: none;\n    height: 20px;\n    width: 20px;\n  }\n}\n\n/* Delete modal */\n\n.section {\n  composes: section from helpers;\n}\n\n.buttons {\n  align-items: center;\n  composes: section from helpers;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.spacer {\n  display: inline-block;\n  width: 1em;\n}\n\n.removeBtn {\n  composes: buttonDanger from helpers;\n}\n\n.cancelBtn {\n  composes: button from helpers;\n}\n\n.deleteLink {\n  padding-right: 10px !important;\n  width: 40px !important;\n  border-bottom: 0px !important;\n  border-radius: 4px;\n}\n\n.searchIcon {\n  padding-right: 0px !important;\n  width: 40px !important;\n  border-bottom: 0px !important;\n}\n.tableRow {\n  outline: auto;\n  outline-color: borderColor;\n  margin-bottom: 0.5rem;\n  width: 100%;\n\n  .tableCell {\n    border-radius: 4px;\n    border-bottom: 0px !important;\n  }\n}\n\n.dropzoneContainer {\n  width: 100%;\n  display: flex;\n  gap: 0.5rem;\n}\n\n.tableSection {\n  width: 100%;\n  border: 0px !important;\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `'styles/colors.css'`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"borderColor": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]}`,
	"children": `styles__children___mGPmZ`,
	"drag": `styles__drag___QlmbX`,
	"dropzoneArea": `styles__dropzoneArea___YjfxO ${___CSS_LOADER_ICSS_IMPORT_1___.locals["dropzoneArea"]}`,
	"dropzoneDisabled": `styles__dropzoneDisabled___X2VLW`,
	"fileFolderIcon": `styles__fileFolderIcon___LK1__`,
	"fileNameInput": `styles__fileNameInput___dsamB`,
	"fileUploadButton": `styles__fileUploadButton___KTMFA`,
	"folderIcon": `styles__folderIcon___uZ6VG styles__fileFolderIcon___LK1__`,
	"folderCell": `styles__folderCell___vAJeS`,
	"childLink": `styles__childLink___u_tj4`,
	"hidden": `styles__hidden___NS9Fg`,
	"none": `styles__none___SuBVX`,
	"lowerUploadControls": `styles__lowerUploadControls___EBYp7`,
	"previewLink": `styles__previewLink___yzCHd`,
	"upIcon": `styles__upIcon___rM2hs`,
	"uploadControls": `styles__uploadControls___ikGjd`,
	"uploadControlsHorizontal": `styles__uploadControlsHorizontal___LPyEk`,
	"uploadText": `styles__uploadText___px3Ua`,
	"download": `styles__download___OIB2x`,
	"preview": `styles__preview___g9kku`,
	"remove": `styles__remove___O9yVx`,
	"section": `styles__section___uR393 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"buttons": `styles__buttons___fACwt ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"spacer": `styles__spacer___biZrX`,
	"removeBtn": `styles__removeBtn___GeAWJ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonDanger"]}`,
	"cancelBtn": `styles__cancelBtn___Y05sv ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"deleteLink": `styles__deleteLink___S62Tz`,
	"searchIcon": `styles__searchIcon____J9kL`,
	"tableRow": `styles__tableRow___qjh8N`,
	"tableCell": `styles__tableCell___LdXRA`,
	"dropzoneContainer": `styles__dropzoneContainer___QxUCR`,
	"tableSection": `styles__tableSection___nJadE`
};
export default ___CSS_LOADER_EXPORT___;
